
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e/[recordId]",
      function () {
        return require("private-next-pages/e/[recordId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e/[recordId]"])
      });
    }
  